export default __webpack_public_path__ + "static/media/me.ba666b34.jpg";